module.exports = __webpack_public_path__ + "static/media/asada-shino-lose.fd2a6e0b.png";